import styled from 'styled-components';
import tw from 'twin.macro';

export const HelperText = styled.span`
  ${tw`mt-1 text-xs flex font-normal leading-4 tracking-normal text-left
	     flex-grow-0 not-italic w-full mb-2`}

  .helperTextClassName {
    height: 20px;
  }
`;
